import { Interface } from '@ethersproject/abi';
import ZERO_EX_PROXY_ABI from './zero-ex-proxy.json';

const ZERO_EX_PROXY_INTERFACE = new Interface(ZERO_EX_PROXY_ABI);

export { ZERO_EX_PROXY_ABI, ZERO_EX_PROXY_INTERFACE };
